import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { activityHistoryActions } from '@store/reducers/manager/activityHistory/actions'
import { getActivityHistoryActions } from '@store/reducers/manager/activityHistory/selectors'
import { projectUsersActions } from '@store/reducers/manager/users/actions'
import * as ActionTypes from '@storeOld/actions'
import axios, { type AxiosResponse } from 'axios'
import { call, put, select } from 'redux-saga/effects'

const fetchProjectActionsHistory = (
  id: string,
  offset?: number
): Promise<AxiosResponse<any>> => {
  const token = localStorage.getItem('token')

  return axios.get(`/projects/${id}/history`, {
    baseURL: import.meta.env.VITE_SYNC_HTTP_URL,
    headers: {
      'X-Auth-Token': token,
    },
    params: {
      ...(offset !== undefined ? { offset } : {}),
    },
  })
}

export function* fetchActionsSaga() {
  try {
    // @ts-expect-error
    const id = yield select(migrationProjectSelector.getProjectId)
    // @ts-expect-error
    const currentActions = yield select(getActivityHistoryActions)

    if (!id) {
      return
    }

    yield put({
      type: activityHistoryActions.setIsLoading.type,
    })

    // @ts-expect-error
    const actionsResponse = yield call(
      fetchProjectActionsHistory,
      id,
      currentActions.length
    )

    const {
      actions,
      users,
      meta: { total },
    } = actionsResponse.data

    if (users.length) {
      yield put({
        type: projectUsersActions.addUsers.type,
        payload: users,
      })
    }

    yield put({
      type: activityHistoryActions.addActivityHistoryActions.type,
      payload: {
        actions,
        total,
      },
    })

    yield put({
      type: activityHistoryActions.setActivityHistoryTotal.type,
      payload: total,
    })
  } catch (error) {
    console.error('Error fetching project:', error)

    yield put({
      type: ActionTypes.SET_ERROR,
      payload: {
        key: 'project',
        message: 'Error fetching project',
      },
    })
  } finally {
    yield put({
      type: activityHistoryActions.setIsLoaded.type,
    })
  }
}
